import React, { Component } from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import axios from "axios";
import { getLangSelector } from "modules/Config/selectors";
import HeaderVialma from "components/HeaderVialma";
import { accessRoutes } from "components/ApplicationRoutes/routes";
import VialmaHelmet from "components/VialmaHelmet";

class ForgotPassword extends Component {
  state = {
    email: "",
    showConfirm: false,
    error: null,
  };
  submit = () => {
    const { email } = this.state;
    const { t, lang, location } = this.props;
    const isJazz = Boolean(location.state && location.state.jazzMode);
    const numberJazzMode = isJazz ? 1 : 0;
    const urlResetPassword = `${process.env.REACT_APP_ENSEMBLE_API}/crm/security/user/password-forgot?lang=${lang}`;
    const formData = new FormData();
    formData.append("email", email);
    formData.append("v", "1");
    formData.append("lang", lang);
    formData.append("jazzMode", numberJazzMode);
    axios({
      url: urlResetPassword,
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: formData,
    })
      .then((response) => {
        if (response.data.status) {
          this.setState({ showConfirm: true });
        } else {
          this.setState({ error: t("FORGOT_PASSWORD_EMAIL_VALIDATION") });
        }
      })
      .catch((error) => {
        this.setState({ error: t("FORGOT_PASSWORD_EMAIL_VALIDATION") });
      });
  };
  handlerInput = (event) => {
    this.setState({ email: event.target.value });
  };
  signUp = () => {
    const { history, lang } = this.props;
    history.push({
      pathname: `/${lang}/`,
      state: { modal: true },
    });
  };
  render() {
    const { t, lang, location } = this.props;
    const { error, showConfirm } = this.state;
    const isJazz = location.state && location.state.jazzMode;
    return (
      <div className="forgot-password-container">
        <VialmaHelmet title="Forgot password" route="forgotPassword" xDefault="forgot-password" />
        <HeaderVialma />
        <div className="container-forgot">
          <div className="container-forgot__content">
            <div className="header-text">{t("FORGOT_PASSWORD_1_TITLE")}</div>
            {!showConfirm && (
              <React.Fragment>
                {!error && <div className="subheader">{t("FORGOT_PASSWORD_1_COPY")}</div>}
                {error && (
                  <React.Fragment>
                    <div className="subheader">{t("FORGOT_PASSWORD_SIGN_UP_INSTRUCTIONS_1")}</div>
                    <div className="link-signup" onClick={this.signUp}>
                      {t("FORGOT_PASSWORD_SIGN_UP_INSTRUCTIONS_2")}
                    </div>
                  </React.Fragment>
                )}
                <input type="text" placeholder={t("FORGOT_PASSWORD_GUIDE")} onChange={this.handlerInput} data-cy="forgot-password-email-input" />
                {error && (
                  <div className="error" data-cy="forgot-password-error">
                    {error}
                  </div>
                )}
                <div onClick={this.submit} className={isJazz ? "btn-submit jazz" : "btn-submit"} data-cy="forgot-password-submit">
                  {t("FORGOT_PASSWORD_1_CTA")}
                </div>
              </React.Fragment>
            )}
            {showConfirm && (
              <div className="confirm" data-cy="forgot-password-confirmation">
                <div className="box-text">
                  <div className="text">{t("FORGOT_PASSWORD_RESET_PASSWORD_EMAIL_SENT_1")}</div>
                  <div className="text">{t("FORGOT_PASSWORD_RESET_PASSWORD_EMAIL_SENT_2")}</div>
                </div>
                <Link
                  to={isJazz ? `${accessRoutes[lang].jazzLandingPage}` : `${accessRoutes[lang].classicalLandingPage}`}
                  className={isJazz ? "btn-submit jazz" : "btn-submit"}
                >
                  {t("MY_ACCOUNT_UNSUBSCRIBE_CLOSE")}
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  lang: getLangSelector(state),
});

export default withTranslation()(connect(mapStateToProps, null)(ForgotPassword));
